import { Link } from 'react-router-dom';
import { CheckCircle, Megaphone, Clock, ArrowRight } from 'lucide-react';
import PublicNav from '../components/PublicNav';

export default function AdvertiseSuccessPage() {
  return (
    <div className="min-h-screen bg-dark-900 flex flex-col">
      <PublicNav />

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="w-20 h-20 rounded-full bg-emerald-500/15 flex items-center justify-center mx-auto">
            <CheckCircle className="w-10 h-10 text-emerald-400" />
          </div>

          <div>
            <h1 className="text-2xl font-bold text-white mb-2">Payment Received!</h1>
            <p className="text-gray-400">Your ad request has been submitted and is under review.</p>
          </div>

          <div className="bg-dark-800 border border-dark-700/50 rounded-2xl p-5 text-left space-y-3">
            {[
              { icon: CheckCircle, color: 'text-emerald-400', label: 'Payment confirmed by Stripe' },
              { icon: Megaphone,   color: 'text-amber-400',   label: 'Ad under team review (usually a few hours)' },
              { icon: Clock,       color: 'text-blue-400',    label: 'Timer starts when your ad is approved and goes live' },
              { icon: CheckCircle, color: 'text-violet-400',  label: 'Ad turns off automatically — no action needed' },
            ].map((step, i) => (
              <div key={i} className="flex items-center gap-3">
                <step.icon className={`w-4 h-4 flex-shrink-0 ${step.color}`} />
                <span className="text-sm text-gray-300">{step.label}</span>
              </div>
            ))}
          </div>

          <p className="text-xs text-gray-500">
            A receipt has been sent to your email. Questions?{' '}
            <a href="mailto:info@haythix.com" className="text-accent-primary hover:underline">
              info@haythix.com
            </a>
          </p>

          <Link to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-primary text-dark-900 rounded-xl font-bold text-sm hover:bg-accent-primary/90 transition-colors">
            Go to Platform <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
